import React, { useState, useEffect } from 'react';
import { MessageSquare, Send, X, CheckCircle, Clock, AlertCircle } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL !== undefined && process.env.REACT_APP_BACKEND_URL !== '' ? process.env.REACT_APP_BACKEND_URL : '';

const TanyaITModal = ({ isOpen, onClose, currentTiket, onSubmit }) => {
  const [kategori, setKategori] = useState('masukan');
  const [subjek, setSubjek] = useState('');
  const [pesan, setPesan] = useState('');
  const [prioritas, setPrioritas] = useState('medium');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (currentTiket) {
      setKategori(currentTiket.kategori || 'masukan');
      setSubjek(currentTiket.subjek || '');
      setPesan(currentTiket.pesan || '');
      setPrioritas(currentTiket.prioritas || 'medium');
    }
  }, [currentTiket]);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const formData = new FormData();
      formData.append('kategori', kategori);
      formData.append('subjek', subjek);
      formData.append('pesan', pesan);
      formData.append('prioritas', prioritas);

      const token = localStorage.getItem('token');
      const response = await fetch(`${API_URL}/api/tiket-it`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        },
        body: formData
      });

      if (response.ok) {
        const result = await response.json();
        onSubmit(result);
        handleClose();
      } else {
        const errorData = await response.json();
        setError(errorData.detail || 'Gagal mengirim tiket');
      }
    } catch (err) {
      setError('Terjadi kesalahan saat mengirim tiket');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setKategori('masukan');
    setSubjek('');
    setPesan('');
    setPrioritas('medium');
    setError('');
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="sticky top-0 bg-gradient-to-r from-primary-600 to-primary-700 text-white p-6 rounded-t-2xl">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <MessageSquare size={28} />
              <h2 className="text-2xl font-bold">Tanya IT</h2>
            </div>
            <button
              onClick={handleClose}
              className="p-2 hover:bg-white/20 rounded-full transition-colors"
            >
              <X size={24} />
            </button>
          </div>
          <p className="mt-2 text-primary-100">
            Kirim masukan, keluhan, atau rekomendasi fitur kepada tim IT
          </p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg flex items-center gap-2">
              <AlertCircle size={20} />
              <span>{error}</span>
            </div>
          )}

          {/* Kategori */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Kategori Tiket
            </label>
            <select
              value={kategori}
              onChange={(e) => setKategori(e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
              required
            >
              <option value="masukan">Masukan / Saran</option>
              <option value="keluhan">Keluhan</option>
              <option value="rekomendasi">Rekomendasi Fitur</option>
              <option value="bug">Lapor Bug</option>
              <option value="error">Error Sistem</option>
            </select>
          </div>

          {/* Prioritas */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Prioritas
            </label>
            <select
              value={prioritas}
              onChange={(e) => setPrioritas(e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
            >
              <option value="low">Low - Rendah</option>
              <option value="medium">Medium - Sedang</option>
              <option value="high">High - Tinggi</option>
              <option value="urgent">Urgent - Mendesak</option>
            </select>
          </div>

          {/* Subjek */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Subjek / Judul
            </label>
            <input
              type="text"
              value={subjek}
              onChange={(e) => setSubjek(e.target.value)}
              placeholder="Contoh: Fitur export Excel untuk laporan"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
              required
            />
          </div>

          {/* Pesan */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Detail Pesan
            </label>
            <textarea
              value={pesan}
              onChange={(e) => setPesan(e.target.value)}
              placeholder="Jelaskan detail masukan, keluhan, atau rekomendasi Anda secara lengkap..."
              rows={6}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent resize-none"
              required
            />
          </div>

          {/* Submit Button */}
          <div className="flex gap-3 pt-4">
            <button
              type="button"
              onClick={handleClose}
              className="flex-1 px-6 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors font-semibold"
            >
              Batal
            </button>
            <button
              type="submit"
              disabled={loading}
              className="flex-1 px-6 py-3 bg-gradient-to-r from-primary-600 to-primary-700 text-white rounded-lg hover:from-primary-700 hover:to-primary-800 transition-all font-semibold flex items-center justify-center gap-2 disabled:opacity-50"
            >
              {loading ? (
                <>Mengirim...</>
              ) : (
                <>
                  <Send size={20} />
                  Kirim Tiket
                </>
              )}
            </button>
          </div>
        </form>

        {/* Info */}
        <div className="px-6 pb-6">
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <p className="text-sm text-blue-800">
              <strong>Catatan:</strong> Tim IT akan merespon tiket Anda secepat mungkin.
              Anda dapat melihat status dan balasan di menu "Tanya IT".
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TanyaITModal;
